<template>
    <div class="order">
        <div @click="goBack" class="goBack">
            <span><i class="el-icon-arrow-left"></i> My Orders</span>
        </div>
        <div style="display: flex;align-items: center;">
            <p style="font-size: 4.267vw;font-weight: bold;margin-right: 2.933vw;">{{ Sub.orderNo }}</p>
            <img @click="export1()" src="@/assets/imgs/uploads/mobile/Group 651.png" style="width: 7.2vw;height: 7.2vw;"
                alt="">
        </div>
        <p style="font-size: 3.467vw;color: #959595;">{{ Sub.createTime }}</p>
        <div style="display: flex;">
            <div class="stus" :style="getOrderStyle(Sub)">{{ getStatusText(Sub.status) }}
            </div>
            <el-button v-if="Sub.status == 0"
                style=" width: 34.133vw;height: 9.6vw;padding: 0;margin-bottom: 2vw;margin-left: 2vw;" type="primary"
                @click="open">Change order</el-button>
        </div>

        <div class="content" v-if="orderSubs.length > 0">
            <p class="tit">Order details</p>
            <div style="overflow: hidden;">
                <div style="overflow-x: scroll;height: 310px;">
                    <div style="border-bottom: 1px solid #D9D9D9;padding-bottom: 1.6vw;" v-for="(item, index) in orderSubs"
                        :key="index">
                        <div class="goods">
                            <div>
                                <img class="pic" v-lazy="item.imageUrl" />
                            </div>
                            <div style="margin-left: 1.867vw;font-size: 3.467vw;width: 39.467vw;">
                                <div style="margin-bottom: 8px;font-weight: bold;">{{
                                    item.skuName }}</div>
                                <div style="color: #959595;text-align: right;">Unit Price: ${{ item.price }}</div>
                            </div>
                        </div>
                        <div
                            style="display: flex;justify-content: space-between;padding: 0 14px 0 10px;font-size: 3.467vw;">
                            <p>Qty: {{ item.num }}</p>
                            <p>Amount: ${{ item.amount }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin: 5.067vw 0 0 2.667vw;color: #959595;font-size: 4vw;">
                <p>Selected <span style="color: #333;">{{ Sub.skuQty }}</span> products</p>
                <p style="margin-top: 2.133vw;">Total <span style="color: #333;">{{ Sub.totalNum }}</span> items</p>
            </div>
            <div
                style="margin: 4.8vw 4.267vw 0 2.667vw;font-size: 4vw;font-weight: bold;display: flex;justify-content: space-between;">
                <p>Grand Total: </p>
                <p>${{ Sub.totalAmount }}</p>
            </div>
        </div>
        <div class="content" style="margin-top: 4.267vw;padding: 5.6vw 0 12.8vw 2.667vw;" v-if="orderSubs.length > 0">
            <p style="font-weight: bold;color: #545454;margin-bottom: 9.867vw;">Shipping details</p>
            <div>
                <p style="font-size: 3.2vw;font-weight: bold;color: #959595;">Order Contact</p>
                <div style="color: #545454;">
                    <div style="margin-top: 2.667vw;">{{ user.nickName }}</div>
                    <div style="margin-top: 2.667vw;">{{ user.email }}</div>
                    <div style="margin-top: 2.667vw;">{{ user.phone }}</div>
                </div>
                <p style="font-size: 3.2vw;font-weight: bold;color: #959595;margin-top: 13.333vw;">Shipping Address</p>
                <div style="color: #545454;">
                    <div style="margin-top: 2.667vw;">{{ add.nickName }}</div>
                    <div style="margin-top: 2.667vw;">{{ add.address }}</div>
                    <div style="margin-top: 2.667vw;">{{ add.country }}</div>
                    <div style="margin-top: 2.667vw;">{{ add.zipCode }}</div>
                </div>
            </div>
        </div>
        <div class="content" style="margin-top: 4.267vw;padding: 5.6vw 0 12.8vw 2.667vw;">
            <p style="font-weight: bold;color: #545454;margin-bottom: 9.867vw;">Time Table</p>
            <div>ETD: {{ dtime }}</div>
            <div>ETA: {{ atime }}</div>
        </div>
    </div>
</template>
  
<script>
import { saveAs } from "file-saver"
export default {
    data() {
        return {
            orderSubs: [],// 订单列表
            Sub: [],
            user: '',
            add: '',
            atime: '',
            dtime: '',
        };
    },
    mounted() {
        this.activated()
        this.getuser()
        this.getOrderAddress()
    },
    methods: {
        getOrderAddress() {
            this.$axios
                .post("/api/mall/orderSub/getOrderAddress", { id: this.$route.query.id })
                .then(res => {
                    if (res.data.code === 200) {
                        this.add = res.data.data;
                    } else {
                        this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        activated() {
            // 获取订单数据
            this.$axios
                .post("/api/mall/orderSub/" + this.$route.query.id)
                .then(res => {
                    if (res.data.code === 200) {
                        this.orderSubs = res.data.data;
                        this.Sub = this.orderSubs[0];
                        this.dtime = this.time(this.Sub.sailingTime)
                        this.atime = this.time(this.Sub.arrivalTime)
                    } else {
                        this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        time(value) {
            if (value !== null && value !== "" && value !== undefined) {
                let date = new Date(value);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                month = month < 10 ? "0" + month : month;
                day = day < 10 ? "0" + day : day;
                date = year + "-" + month + "-" + day;
                return date;
            }
        },
        goBack() {
            this.$router.go(-1)
        },
        getOrderStyle(item) {
            return {
                color: this.getBorderColor(item.status),
                backgroundColor: this.getStatusColor(item.status),
                borderColor: this.getBorderColor(item.status),
            };
        },
        getStatusText(status) {
            switch (status) {
                case 0:
                    return 'Pending';
                case 1:
                    return 'Shipped';
                case 2:
                    return 'Delivered';
                default:
                    return 'null';
            }
        },
        getStatusColor(status) {
            switch (status) {
                case 0:
                    return '#EDE2FF';
                case 1:
                    return '#FFF5CE';
                case 2:
                    return '#D9D9D9';
                default:
                    return 'white';
            }
        },
        getBorderColor(status) {
            switch (status) {
                case 0:
                    return '#8A43FF';
                case 1:
                    return '#FFB800';
                case 2:
                    return '#959595';
                default:
                    return 'black';
            }
        },
        getuser() {
            this.$axios
                .post("/api/mall/orderSub/getUserDetail", {
                    id: this.$store.getters.getUser.id
                })
                .then(res => {
                    if (res.data.code === 200) {
                        this.user = res.data.data;
                    } else {
                        this.notifyError(res.data.message);
                    }
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        open() {
            this.$confirm('The order will be cancelled, and the items of this order will be return to the shopping cart again.Please update in the shopping cart. If there are some items will be submitted to order in shopping cart, please submit firstly, and then update this order. Are you sure to continue?', 'Warning', {
                confirmButtonText: 'confirm',
                cancelButtonText: 'cancel',
                customClass: "mypopper",
                center: true
            }).then(() => {
                this.$axios
                    .post("/api/mall/order/resetting", {
                        memberId: this.$store.getters.getUser.id,
                        id: this.$route.query.id
                    })
                    .then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: 'success',
                                showClose: true,
                                message: 'Operation successful'
                            });
                            window.location.reload();
                            this.$router.push({
                                path: '/personalcenter/Orderlist',
                            })
                        }
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    });

            }).catch(() => {
                this.$message({
                    type: 'info',
                    showClose: true,
                    message: 'Operation has been canceled'
                });
            });
        },
        export1() {
            this.$axios
                .post("/api/mall/orderSub/getSubExportList", {
                    orderId: this.$route.query.id
                }, { responseType: "blob" })
                .then(res => {
                    const obj = res.data
                    saveAs(obj, '订单明细.xlsx')
                })
        }
    }

}
</script>
  
<style scoped>
.order {
    padding: 20px 28px 30px 21px;
}

.content {
    width: 247px;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    padding-bottom: 27px;
}

/* 订单为空的时候显示的内容CSS */
.order .order-empty {
    width: 375px;
    margin: 0 auto;
}

.order .order-empty .empty {
    height: 300px;
    padding: 0 auto;
    margin: 65px 0 0;
    color: #b0b0b0;
    overflow: hidden;
}

.order .order-empty .empty h2 {
    margin: 70px 0 15px;
    font-size: 36px;
}

.order .order-empty .empty p {
    margin: 0 0 20px;
    font-size: 20px;
}

.kuanshi {
    color: #855d5d;
    font-size: 14px;
    margin-left: 10px;
}

.goBack {
    font-size: 16px;
    font-weight: bold;
    color: #959595;
    margin-bottom: 16px;
}

.tit {
    margin: 9px 0 15px 10px;
    font-size: 16px;
    font-weight: bold;
    color: #545454;
}

.goods {
    padding: 10px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.pic {
    height: 62px;
    width: 62px;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
}

.details {
    width: 381px;
    height: 385px;
    margin-top: 18px;
    margin-left: 12px;
    padding-left: 27px;
    padding-top: 21px;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
}

.btm2 {
    margin-top: 14px;
    margin-left: 28px;
    display: flex;
    justify-content: space-between;
}

.stus {
    width: 78px;
    height: 22px;
    text-align: center;
    font-size: 12px;
    border-radius: 23px;
    border: 1px solid #959595;
    margin: 10px 0 13px;
}
</style>
<style>
.el-message-box {
    width: 80% !important;
}
</style>